<template minapp='mpx' xlang='wxml'>
  <from-item isShow="{{isShow}}" 
    isRequired="{{isRequired}}" 
    isRequiredShow="{{isRequiredShow}}" 
    label="昵称" 
    innerValue="{{innerValue}}"
  > 
    <es-field placeholder="请输入昵称" wx:model="{{innerValue}}" slot="input"/>
  </from-item>
</template>

<script>
  import { watch } from "@mpxjs/core";
  import { hasRequired } from '@/utils'
  import { createComponent } from '@didi/es-mpx-creator'
  createComponent({
    classes: [],
    data: {
      innerValue:''
    },
    props: {
      value:{
        type: String,
        value: ''
      },
      isShow:{
        type: Boolean,
        value: true
      },
      item:Object,
      selectedCardList:Array,
      isNeedCard:Boolean,
      isRequiredShow: {
        type: Boolean,
        value: false
      },
    },
    computed: {
      isRequired() {
        // TODO: 删除多余代码,hasRequired函数的返回值可统一由外部传入
        let selectedCardList = []
        if(this.isNeedCard){
          selectedCardList = this.selectedCardList
        }
        return hasRequired(this.item?.requiredcCrdTypes,this.selectedCardList,this.item?.isRequired,this.isNeedCard)
      }
    },
    methods: {
    },
    watch:{
      value(val) {
        this.innerValue = val
      },
      //将数据回传
      innerValue(newValue) {
        this.$trigger( 'input', {value:newValue} )
      },
    }
  })
</script>

<style lang='stylus' scoped>
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'es-cell': '@didi/es-mpx-ui/lib/cell',
      'es-field': '@didi/es-mpx-ui/lib/field',
      'from-item': './from-item'
    }
  }
</script>

